import React, { useState, useEffect } from "react";
import { Card, Button, Row, Col, Carousel, Container } from "react-bootstrap";
import { FaEdit, FaEye, FaBarcode, FaQrcode } from "react-icons/fa";
import { useAuth } from "../AuthContext";
import Carga from "../componentes/cargando/Cargando";
import "../static/css/listaProductos.css";
import {buscarProductoServicio} from "../service/productos/buscarProducto";
import {useNavigate} from "react-router-dom";
import {generarBarcodeProductoService} from "../service/productos/productoService";

const ListaProductos = () => {
    const navigate = useNavigate();
    const { verificacionToken } = useAuth();
    const [cargando, setCargando] = useState(true);
    const [ productos, setProductos ] = useState([]);
    const [view, setView] = useState("list");


    const buscarProductos = async () => {
        const respuesta = await buscarProductoServicio()
        if (respuesta[0]) {
            setProductos(respuesta[1]);
        } else {
            if (respuesta[1] === 400) {
                setProductos([]);
            } else if (respuesta[1] === 401) {
                navigate("/expiro-sesion");
            } else if (respuesta[1] === 403) {
                navigate("/no-autorizado");
            } else {
                navigate("/no-encontrado");
            }
        }
    }

    useEffect(() => {
        verificacionToken("ROLE_DUENO");
        buscarProductos()
        setCargando(false)
    }, []);

    if (cargando) return <Carga />;

    const handleEditar = (producto) => {
        navigate(`/productos/editar/${producto.id}`);
    }
    const handleVer = (producto) => console.log("Ver", producto);

    const handleCodigoBarras = async (id) => {
        const respuesta = await generarBarcodeProductoService(id)
        console.log(respuesta)
    };

    const handleQRCode = (producto) => console.log("QR", producto);

    return (
        <Container fluid className="mt-4 pb-5">
            {productos.length === 0?(
                <div className="text-center">
                    <h1>
                        No se Encontraron los Productos!!
                    </h1>
                </div>
            ):
                (
                    <Row xs={1} md={2} lg={4} className="g-4">
                        {productos.map((producto, idx) => (
                            <Col key={idx}>
                                <Card className="producto-card shadow-sm h-100">
                                    {producto.paths_productos
                                    && producto.paths_productos
                                        .length > 0 ? (
                                        <Carousel interval={null}>
                                            {producto.paths_productos
                                                .map((img, i) => (
                                                    <Carousel.Item key={i}>
                                                        <img
                                                            className="d-block w-100"
                                                            src={`${process.env.REACT_APP_API_URL}/uploads/${img.path}`}
                                                            alt={`Imagen ${i + 1}`}
                                                            style={{ height: "200px", objectFit: "cover" }}
                                                        />
                                                    </Carousel.Item>
                                                ))}
                                        </Carousel>
                                    ) : (
                                        <Card.Img
                                            variant="top"
                                            src="https://placehold.co/300x200?text=Sin+Imagen&bg=cccccc&fc=000000"
                                            style={{ height: "200px", objectFit: "cover" }}
                                        />
                                    )}
                                    <Card.Body className="d-flex flex-column">
                                        <Card.Title>{producto.nombre}</Card.Title>
                                        <Card.Text className="text-muted">
                                            {producto.descripcion || "Sin descripción"}
                                        </Card.Text>
                                        <div className="mt-auto d-flex justify-content-between flex-wrap">
                                            <Button
                                                className="btn-rosa mb-1"
                                                size="sm"
                                                onClick={() => handleEditar(producto)}
                                            >
                                                <FaEdit /> Editar
                                            </Button>
                                            <Button
                                                className="btn-rosa-secundario mb-1"
                                                size="sm"
                                                onClick={() => handleVer(producto)}
                                            >
                                                <FaEye /> Ver
                                            </Button>
                                            <Button
                                                className="btn-rosa mb-1"
                                                size="sm"
                                                onClick={() => handleCodigoBarras(producto.id)}
                                            >
                                                <FaBarcode /> Código de barras
                                            </Button>
                                            <Button
                                                className="btn-rosa-secundario mb-1"
                                                size="sm"
                                                onClick={() => handleQRCode(producto)}
                                            >
                                                <FaQrcode /> QR
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
        </Container>
    );
};

export default ListaProductos;